import React from 'react';
import { useSelector } from 'react-redux';
import AccessDenied from '../pages/access-denied/Access';

// Función auxiliar para verificar las funcionalidades
const hasFuncionalidades = (usuario, funcionalidadesRequeridas) => {
  if (!usuario || !usuario.funciones) return false;
  return funcionalidadesRequeridas.every(funcRequerida => 
    usuario.funciones.some(func => func.descripcion === funcRequerida)
  );
};

const AuthCheck = ({ children, funcionalidadesRequeridas }) => {
  const storedAuth = localStorage.getItem('auth');

let usuario = null;
let isAuthenticated = false;

if (storedAuth) {
  try {
    const parsedAuth = JSON.parse(storedAuth);
    if (parsedAuth?.usuario && parsedAuth?.token) {
      usuario = parsedAuth.usuario;
      isAuthenticated = true;
    }
  } catch (error) {
    console.error('Error parsing stored auth data:', error);
  }
}

  const tieneAcceso = isAuthenticated && hasFuncionalidades(usuario, funcionalidadesRequeridas);

  if (!tieneAcceso) {
    return <></>;
  }

  return children;
};

export default AuthCheck;

